import { render, staticRenderFns } from "./SidebarAddNewBankAccount.vue?vue&type=template&id=08cc18e2&"
import script from "./SidebarAddNewBankAccount.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewBankAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports